import { RuleResult } from 'types/DeclarationP5'
import { CL147_SECURITY_AGREEMENT_AREA_COUNTRIES } from 'shared/ncts/common/constants'
import { removePrefix } from 'shared/ncts/common/classifier-util'
import { CustomsOfficeOfTransitDeclared } from '../../common/types'

const C0598Validator = {
  validateTransitOfficeDateTimeRequirement: ({
    security,
    transitCustomsOffice,
  }: {
    security: string
    transitCustomsOffice?: CustomsOfficeOfTransitDeclared
  }): RuleResult => {
    if (['1', '3'].includes(security) && CL147_SECURITY_AGREEMENT_AREA_COUNTRIES
      .includes(removePrefix(transitCustomsOffice?.referenceNumber, 'TRANSIT_OFFICE_', 2) ?? '')) {
      return 'REQUIRED'
    }

    return 'OPTIONAL'
  },
} as const

export default C0598Validator
